import { Injectable } from '@angular/core';
import { Status } from '@essent/common';
import { isDefined } from '@essent/core-utils';
import type { FunctionalErrorItemRendering } from '@functional-errors/models';
import {
  getFunctionalErrorAction,
  selectFunctionalEntity,
} from '@functional-errors/store';
import { Store } from '@ngrx/store';
import type { Observable } from 'rxjs';
import { of } from 'rxjs';
import { filter, map, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class FunctionalErrorsService {
  private readonly functionalError$ = (key: string) =>
    this.store$.select(selectFunctionalEntity(key));

  getFunctionalError(
    key: string | undefined
  ): Observable<FunctionalErrorItemRendering | undefined> {
    if (key === undefined) {
      return of(undefined);
    }
    return this.functionalError$(key).pipe(
      tap((functionalEntity) => {
        if (
          functionalEntity === undefined ||
          functionalEntity.status === Status.IDLE
        ) {
          this.store$.dispatch(
            getFunctionalErrorAction({ payload: undefined, actionId: key })
          );
        }
      }),
      filter(isDefined),
      map((item) => item.entry)
    );
  }

  constructor(private readonly store$: Store) {}
}
